import React from 'react';
import styled from 'styled-components';
import Values from 'values.js';

import { useTheme, useStrings } from 'src/providers';

import { ReactComponent as Bullet } from 'src/images/bullet-checkmark.svg';

const StyledBulletPoints = styled.ul<{ colors: { checkmark: string } }>`
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 0 0.25em;
  padding: 0;
  list-style: none;

  .bullet {
    display: flex;
    line-height: 1.25em;
    margin: 0 0 0.75em 0;

    .checkmark {
      min-width: 0.75em;
      margin: 0.3em 0.75em 0 0;
      color: ${({ colors }) => colors.checkmark}
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

interface IBulletPointsProps {
  className?: string;
}

export function BulletPoints(props: IBulletPointsProps) {
  const { className } = props;
  const { bullets } = useStrings();
  const { merchantColor } = useTheme();

  const color = React.useMemo(() => new Values(merchantColor), [merchantColor]);
  const colors = { checkmark: color.hexString() };

  return (
    <StyledBulletPoints className={`bullets ${className}`} colors={colors} data-test="bullets">
      {
        bullets.map((bullet: string, idx: number) => (
          <li key={idx} className="bullet">
            <Bullet className="checkmark" />
            <span className="text">{bullet}</span>
          </li>
        ))
      }
    </StyledBulletPoints>
  );
}
